module.exports = __webpack_public_path__ + "static/media/scheduler-license.5cf38b99.png";